import { Link } from "@tanstack/react-router"
import { Button } from "@/components/ui/button"
import { ArrowRight, Zap, Shield, Puzzle } from "lucide-react"

export function HeroCompact() {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-background via-background to-primary/5">
      {/* Subtle animated background gradient */}
      <div className="absolute inset-0 bg-gradient-to-r from-primary/5 via-transparent to-primary/5 animate-pulse" />

      <div className="container relative px-6 py-16 sm:py-20">
        <div className="mx-auto max-w-3xl text-center">
          {/* Badge */}
          <div className="mb-6 inline-flex items-center rounded-full border bg-background px-3 py-1 text-sm">
            <Zap className="mr-2 h-4 w-4 text-primary" />
            Secured Enterprise Integration & Agentic AI Platform
          </div>

          {/* Main heading */}
          <h1 className="text-3xl font-bold tracking-tight text-foreground sm:text-5xl lg:text-6xl">
            Welcome to
            <span className="text-primary"> Matricks.ai</span>
          </h1>

          {/* Subheading */}
          <p className="mx-auto mt-4 max-w-xl text-base leading-7 text-muted-foreground sm:text-lg">
            Smart Proxy Gateway with Zero-Trust Architecture. Connect, manage, and secure
            all your APIs and AI agents through a unified platform.
          </p>

          {/* Key features inline */}
          <div className="mt-6 flex flex-wrap justify-center gap-4 text-sm text-muted-foreground">
            <div className="flex items-center">
              <Shield className="mr-1.5 h-4 w-4 text-primary" />
              Cedar Policies
            </div>
            <div className="flex items-center">
              <Puzzle className="mr-1.5 h-4 w-4 text-primary" />
              2000+ Integrations
            </div>
            <div className="flex items-center">
              <Zap className="mr-1.5 h-4 w-4 text-primary" />
              Zero-Latency
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
            <Button size="lg" className="px-6" asChild>
              <Link to="/login">
                Get Started
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
            <Button variant="outline" size="lg" className="px-6" asChild>
              <a href="#platform">
                Explore Platform
              </a>
            </Button>
          </div>

          {/* Trust indicators */}
          <div className="mt-12 grid grid-cols-3 gap-6 sm:gap-12">
            <div>
              <div className="text-2xl font-bold text-primary sm:text-3xl">99.9%</div>
              <div className="mt-1 text-xs text-muted-foreground sm:text-sm">Uptime SLA</div>
            </div>
            <div>
              <div className="text-2xl font-bold text-primary sm:text-3xl">&lt;10ms</div>
              <div className="mt-1 text-xs text-muted-foreground sm:text-sm">Latency</div>
            </div>
            <div>
              <div className="text-2xl font-bold text-primary sm:text-3xl">2000+</div>
              <div className="mt-1 text-xs text-muted-foreground sm:text-sm">Integrations</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
